import { deepFreeze } from 'library-components/utils/lodashex';
import { E_Language } from '../types';
export const LANGUAGES = deepFreeze([
    { key: E_Language.en, label: 'English' },
    { key: E_Language.cn, label: '简体中文' },
    { key: E_Language.tw, label: '繁体中文' },
    { key: E_Language.jp, label: '日本语' }
]);
export function getSupportEmail(isCN) {
    if (isCN) {
        return 'support@patsnap.com';
    }
    return 'help@patsnap.com';
}
export function getSupportTel(isCN) {
    if (isCN) {
        return '400-694-4481';
    }
    return '';
}
export function getDefaultCountryCode() {
    return '+86';
}
export const noRedirectRouterList = ['invitation'];
